import { axiosAdapter, http } from '@inertiajs/core'
import axios, { type AxiosError, type InternalAxiosRequestConfig } from 'axios'
window.axios = axios

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

type RetriedRequestConfig = InternalAxiosRequestConfig & { _retry?: boolean }

window.axios.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config as RetriedRequestConfig | undefined

    if (error.response?.status === 419 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        await window.axios.get('/sanctum/csrf-cookie')

        return window.axios(originalRequest)
      } catch (csrfError) {
        return Promise.reject(csrfError instanceof Error ? csrfError : new Error(String(csrfError)))
      }
    }

    return Promise.reject(error)
  },
)

http.setClient(axiosAdapter(window.axios))
